import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import ListGroup from 'containers/ListGroup';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import groupActions from 'core/groups/actions';
import dataActions from 'core/data/actions';

import commonStyles from 'groups/styles';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    desktopLabel: {
      ...common.desktopLabel,
      fontSize: 14,
      fontWeight: theme.typography.fontWeights.normal,
      margin: [0, 'auto', theme.spacing.xs],
      maxWidth: 440,
    },
    mobileLabel: {
      ...common.mobileLabel,
      fontSize: 14,
      fontWeight: theme.typography.fontWeights.normal,
      margin: [0, 'auto', theme.spacing.xs],
      maxWidth: 440,
    },
  };
};

const PrimaryUserBare = ({
  bottomContent,
  classes,
  label,
  labelMobile,
  name,
  onDone,
  onEdit,
  subText,
}) => (
  <>
    <legend className={classnames('grp-label', classes.label)}>
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <RawHtml className={classnames('content', classes.content, classes.hidden)}>{subText}</RawHtml>

    <ErrorMsg name={name} type="group" />

    <ListGroup groupName={name} onDone={onDone} onEdit={onEdit} />

    <BottomContent className="bottomContent">{bottomContent}</BottomContent>
  </>
);

PrimaryUserBare.propTypes = {
  bottomContent: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.shape({
    appRequest_primary_firstName: PropTypes.string,
    appRequest_primary_lastName: PropTypes.string,
  }),
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  subText: PropTypes.string,
};

PrimaryUserBare.defaultProps = {
  bottomContent: '',
  data: {},
  label: '',
  labelMobile: '',
  subText: '',
};

const PrimaryUserStyled = withStyles(styles)(PrimaryUserBare);

const mapStateToProps = ({ data, groups }, { name }) => ({
  bottomContent: groups[name]?.bottomContent,
  data: groups[name]?.fields?.reduce((acc, key) => ({ ...acc, [key]: data[key] }), {}),
  label: groups[name]?.label,
  labelMobile: groups[name]?.labelMobile,
  primaryUserResources: groups[name]?.resources,
  subText: groups[name]?.subText,
});

const mapDispatchToProps = {
  onDone: groupActions.update,
  onEdit: dataActions.changeData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryUserStyled);
